export default "/images/Logo-9T-Thick-Gold.svg?f7224e4acc2c47ce0a49c5f4721d2f5e";